<div class="busqueda-user_container">
    <div class="header-busqueda">
        <h2 class="titulo-busqueda">Búsqueda de usuarios</h2>
        <div class="botones-tabs">
            <button
                type="button"
                class="btn-tab"
                [class.active]="activeTab === 'representantes'"
                (click)="cambiarTab('representantes')">
                Empresas
            </button>
            <button
                type="button"
                class="btn-tab"
                *appPermiso="'consultar_usuarios_upra'"
                [class.active]="activeTab === 'gobierno'"
                (click)="cambiarTab('gobierno')">
                Gobierno
            </button>
        </div>
    </div>

    <input
        type="text"
        class="form-control mb-3"
        [placeholder]="
            activeTab === 'representantes'
                ? 'Buscar por NIT, nombre empresa, representante, correo...'
                : 'Buscar por nombre, correo, rol, entidad...'
        "
        [(ngModel)]="searchTerm"
        (input)="onSearchInput()" />

    <!-- TABLA DE REPRESENTANTES -->
    <div *ngIf="activeTab === 'representantes'">
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>NIT</th>
                        <th>Nombre empresa</th>
                        <th>Nombre representante</th>
                        <th>Correo representante</th>
                        <th *appPermiso="'inactivar_usuarios_empresa'">Estado</th>
                        <th *appPermiso="'ver_delegado_empresa'">Representante</th>
                        <th>Empresa</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container
                        *ngIf="
                            (filteredUsers ? filteredUsers : usuarioCompanys)
                                ?.length === 0
                        ">
                        <tr>
                            <td colspan="7" class="text-center">
                                No se encontraron usuarios que coincidan con la
                                búsqueda.
                            </td>
                        </tr>
                    </ng-container>

                    <ng-container
                        *ngFor="
                            let usuario of filteredUsers
                                ? filteredUsers
                                : usuarioCompanys
                        ">
                        <ng-container *ngFor="let empresa of usuario.empresas">
                            <tr>
                                <td>{{ empresa.nit }}</td>
                                <td>{{ empresa.razonSocial }}</td>
                                <td>
                                    {{
                                        getNombreCompleto(usuario.representante)
                                    }}
                                </td>
                                <td>{{ usuario.representante?.email }}</td>
                                <td *appPermiso="'inactivar_usuarios_empresa'">
                                    <button
                                        type="button"
                                        class="btn btn-sm"
                                        [ngClass]="{
                                            'btn-success':
                                                usuario.representante
                                                    ?.estado === 'Activo',
                                            'btn-danger':
                                                usuario.representante
                                                    ?.estado !== 'Activo',
                                        }"
                                        (click)="
                                            actualizarEstado(
                                                usuario.representante?.id,
                                                usuario.representante?.estado
                                            )
                                        "
                                        [title]="
                                            usuario.representante?.estado ===
                                            'Activo'
                                                ? 'Desactivar usuario'
                                                : 'Activar usuario'
                                        ">
                                        {{
                                            usuario.representante?.estado ===
                                            'Activo'
                                                ? 'Activo'
                                                : 'Inactivo'
                                        }}
                                    </button>
                                </td>
                                <td *appPermiso="'ver_delegado_empresa'">
                                    <a
                                        type="button"
                                        class="btn btn-info btn-sm btn_user"
                                        (click)="
                                            abrirModalVerRepresentante(
                                                usuario.representante
                                            )
                                        "
                                        title="Editar datos del representante">
                                        Ver Representante
                                    </a>
                                </td>
                                <td class="conteiner_agente-vig">
                                    <button
                                        type="button"
                                        class="btn btn-warning btn-sm btn_user"
                                        *appPermiso="'ver_empresa_empresa'"
                                        (click)="
                                            abrirModalVerEmpresa(
                                                empresa.id,
                                                usuario.representante
                                            )
                                        "
                                        title="Editar datos de la empresa">
                                        Ver Empresa
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-secondary btn-sm btn_user"
                                        *appPermiso="'ver_direccion_empresa'"
                                        (click)="
                                            abrirModalVerDireccion(empresa.id)
                                        "
                                        title="Editar dirección de la empresa">
                                        Ver Dirección
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>

    <!-- TABLA DE GOBIERNO -->
    <div *ngIf="activeTab === 'gobierno'" class="tabla-gobierno">
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>
                            Usuario
                            <app-icono-filtro
                                tipo="input"
                                placeholder="Filtrar por usuario"
                                (filtrar)="
                                    onFiltro('username', $event)
                                "></app-icono-filtro>
                        </th>
                        <th>
                            Nombre Completo
                            <app-icono-filtro
                                tipo="input"
                                placeholder="Filtrar por nombre"
                                (filtrar)="
                                    onFiltro('nombre', $event)
                                "></app-icono-filtro>
                        </th>
                        <th>
                            Correo electrónico
                            <app-icono-filtro
                                tipo="input"
                                placeholder="Filtrar por correo"
                                (filtrar)="
                                    onFiltro('correo', $event)
                                "></app-icono-filtro>
                        </th>
                        <th>
                            Cargo
                            <app-icono-filtro
                                tipo="input"
                                placeholder="Filtrar por cargo"
                                (filtrar)="
                                    onFiltro('cargo', $event)
                                "></app-icono-filtro>
                        </th>
                        <th>
                            Rol
                            <app-icono-filtro
                                tipo="input"
                                placeholder="Filtrar por rol"
                                (filtrar)="
                                    onFiltro('rol', $event)
                                "></app-icono-filtro>
                        </th>
                        <th>
                            Entidad
                            <app-icono-filtro
                                tipo="input"
                                placeholder="Filtrar por entidad"
                                (filtrar)="
                                    onFiltro('entidad', $event)
                                "></app-icono-filtro>
                        </th>
                        <th *appPermiso="'inactivar_usuarios_upra'">
                            Estado
                            <app-icono-filtro
                                tipo="select"
                                [opciones]="tiposEstado"
                                placeholder="Filtrar por estado"
                                (filtrar)="
                                    onFiltro('estado', $event)
                                "></app-icono-filtro>
                        </th>
                        <th *appPermiso="'ver_detalle_upra'">Detalle</th>
                        <th *appPermiso="'editar_usuarios_upra'">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="filteredGobiernoUsers?.length === 0">
                        <tr>
                            <td colspan="9" class="text-center">
                                No se encontraron usuarios de gobierno que
                                coincidan con la búsqueda.
                            </td>
                        </tr>
                    </ng-container>

                    <tr *ngFor="let gobiernoUser of filteredGobiernoUsers">
                        <td>{{ gobiernoUser.username }}</td>
                        <td>
                            {{ gobiernoUser.nombre }}
                            {{ gobiernoUser.apellido }}
                        </td>
                        <td>{{ gobiernoUser.correo }}</td>
                        <td>{{ gobiernoUser.cargo }}</td>
                        <td>{{ obtenerNombresRoles(gobiernoUser.roles) }}</td>
                        <td>{{ gobiernoUser.entidad }}</td>
                        <td *appPermiso="'inactivar_usuarios_upra'">
                            <button
                                type="button"
                                class="btn btn-sm"
                                (click)="actualizarEstadoGobierno(gobiernoUser.id, gobiernoUser.estado)"
                                [ngClass]="{
                                    'btn-success': gobiernoUser.estado === true,
                                    'btn-danger': gobiernoUser.estado !== true,
                                }"
                                [title]="
                                    gobiernoUser.estado === true
                                        ? 'Desactivar usuario'
                                        : 'Activar usuario'
                                ">
                                {{
                                    gobiernoUser.estado === true
                                        ? 'Activo'
                                        : 'Inactivo'
                                }}
                            </button>
                        </td>
                        <td *appPermiso="'ver_detalle_upra'">
                            <button
                                type="button"
                                class="btn btn-info btn-sm"
                                title="Ver información"
                                (click)="verUsuarioGobierno(gobiernoUser.id)">
                                Ver
                            </button>
                        </td>
                        <td *appPermiso="'editar_usuarios_upra'">
                            <button
                                *appPermiso="'editar_usuarios_upra'"
                                type="button"
                                class="btn btn-warning btn-sm"
                                title="Editar usuario"
                                (click)="abrirModalEditarRol(gobiernoUser)">
                                Editar
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
